import { afterNextRender, Component, inject, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { InputComponent } from './core/components/input/input.component';
import { UserService } from './users/user.service';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from './core/components/base.component';
import { DateComponent } from './core/components/date/date.component';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PasswordComponent } from "./core/components/password/password.component";
import { NgClass } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NotificationService } from './core/services/notification.service';

@Component({
  selector: 'app-root',
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [NgxSpinnerModule, NgClass, RouterOutlet, ReactiveFormsModule, InputComponent, DateComponent, NgbDatepickerModule, FormsModule, PasswordComponent]
})
export class AppComponent extends BaseComponent {
  title = 'TPA_Portal_FE';
  dateo: any
  form!: FormGroup;
  userService = inject(UserService);
  notificationService = inject(NotificationService);
  isMenuVisible: boolean = true;

  constructor(private fb: FormBuilder, private renderer: Renderer2) {
    super();
    afterNextRender(() => {
      let currentLanguage = this.userService.getAppCurrentLanguage();
      this.userService.updateBodyDirection(currentLanguage)
      this.translateService.setDefaultLang(currentLanguage);
      this.subscriptions.add(this.translateService.onDefaultLangChange.subscribe((res) => {
        this.userService.updateBodyDirection(res.lang)
        if (res && res.lang !== currentLanguage) {
          this.userService.updateBodyDirection(res.lang)
        }
      }))
    })

  }

  ngOnInit(): void {
    const savedConnectionId = localStorage.getItem('signalRConnectionId');
    if (savedConnectionId) {
      this.notificationService.createNotificationHubConnection();
    }
    this.userService.getUser();
  }

}
